import { BillingPlan } from '@cycle-app/graphql-codegen';

import { BillingUpdateLayout } from 'src/components/BillingUpdateLayout';
import { BillingUpgradeBusinessPlusBox } from 'src/components/BillingUpgradeBusinessPlusBox';
import { StyledCycleLogo } from 'src/components/BillingUpgradeBusinessPlusBox/BillingUpgradeBusinessPlusBox.styles';
import { BillingUpdateFeatures } from 'src/components/BillingUpgradeFeatures';
import { BillingUpgradePricingBox } from 'src/components/BillingUpgradePricingBox';
import { useCurrentBilling, useParams, useProduct } from 'src/hooks';

import { MonochromeGradients } from '../../BillingUpgradeBusinessPlusBox/MonochromeGradients';

export const BillingUpgrade = () => {
  const { product } = useProduct();
  const hasEndDate = !!product?.endOfFreeTrial || !!product?.subscriptionPeriodEnd;
  const params = useParams();
  /**
   * When user is on /app/:slug:/upgrade => Show the page to upgrade to next plan
   * When user is on /app/:slug:/upgrade/:plan: => Show the plan specific page
   */
  const isGlobalUpgradePage = ![BillingPlan.Standard, BillingPlan.BusinessPlus].includes(params.plan as BillingPlan);
  const currentBilling = useCurrentBilling();
  const planToShow = isGlobalUpgradePage
    ? getPlanToUpgrade(currentBilling?.plan, hasEndDate)
    : params.plan as BillingPlan;

  if (!planToShow) return null;

  const title = planToShow === BillingPlan.Standard
    ? 'Enjoy the ride with Pro'
    : 'Go further with Business+';
  const description = planToShow === BillingPlan.Standard
    ? 'Cycle Pro is ideal for teams that want to build solid feedback systems across multiple sources'
    : 'Cycle Business+ is perfect for large teams that want to scale collaboration between product and customer-facing teams';
  const showBusinessBox = planToShow === BillingPlan.BusinessPlus;

  return (
    <BillingUpdateLayout
      title={title}
      description={description}
      main={showBusinessBox
        ? <BillingUpgradeBusinessPlusBox />
        : <BillingUpgradePricingBox />}
      features={(
        <BillingUpdateFeatures plan={planToShow} />
      )}
      {...planToShow === BillingPlan.BusinessPlus && {
        logo: <StyledCycleLogo size={64} />,
        gradients: <MonochromeGradients />,
      }}
    />
  );
};

const getPlanToUpgrade = (currentPlan: BillingPlan | undefined, hasEndDate: boolean) => {
  if (currentPlan === BillingPlan.Free) return BillingPlan.Standard;
  if (currentPlan === BillingPlan.Standard) return hasEndDate ? BillingPlan.Standard : BillingPlan.BusinessPlus;
  return BillingPlan.Standard; // by default
};
